import { Typography, Box, TextField } from "@material-ui/core"
import { String } from "aws-sdk/clients/cloudsearchdomain"
import { PropsWithChildren } from "react"
import styled from "styled-components"

const StyledReportedContentDays = styled(Typography)`
  && {
    font-size: 20px;
    color: ${({ theme }) => theme.colors.accent1};
    margin-left: 1em;
  }
`

const StyledReportedContentDaysArea = styled(Box)`
  && {
    display: flex;
    align-items: center;
    margin-top: 1rem;
    background-color: ${props => props.theme.colors.bgPrimary};
    border-radius: 1rem;
  }
`
export interface INumOfDaysTextField {
  handleOnchange: (event) => void
  value: String
}

const NumOfDaysTextField = ({ handleOnchange, value }: PropsWithChildren<INumOfDaysTextField>) => {
  return (
    <>
      <StyledReportedContentDaysArea>
        <TextField
          fullWidth
          onChange={handleOnchange}
          InputProps={{ disableUnderline: true }}
          value={value}
          type="number"
          placeholder="Type number of days"
        />
      </StyledReportedContentDaysArea>
    </>
  )
}

export default NumOfDaysTextField

